import React from 'react'
import { I18n } from 'react-redux-i18n'
import ScheduleModal from 'components/ScheduleModal'
import _clonedeep from 'lodash.clonedeep'
import { ButtonTag } from 'components/Form'
import Switch from './Switch'

const schedule = [{
  isActive: false,
  name: 'channels',
  timeZone: 'Europe/Madrid',
  monday: {
    isActive: false,
    ranges: [],
  },
  tuesday: {
    isActive: false,
    ranges: [],
  },
  wednesday: {
    isActive: false,
    ranges: [],
  },
  thursday: {
    isActive: false,
    ranges: [],
  },
  friday: {
    isActive: false,
    ranges: [],
  },
  saturday: {
    isActive: false,
    ranges: [],
  },
  sunday: {
    isActive: false,
    ranges: [],
  },
}]


/**
 * ScheduleButton
 * @param {object} props
 */
const IsActiveNauta = (props) => {
  const { id, propName, value = {}, onChange, className, label, description, scheduleNauta } = props
  const [modalSchedule, setModalSchedule] = React.useState(false)
  const toggleModalSchedule = () => { setModalSchedule(!modalSchedule) }
  const saveSchedule = (_schedule) => {
    return new Promise((resolve, reject) => {
      const displaySchedule = {
        ..._schedule,
        name: _schedule.name || schedule[0].name,
        timeZone: _schedule.timeZone || schedule[0].timeZone,
        isActive: _schedule.isActive || schedule[0].isActive
      }
      onChange(displaySchedule, 'scheduleNauta')
      return resolve()
    })
  }

  return (
    <>
      <div className={`channel-field input ${className ? className : ''}`}>
        <Switch
          id={id}
          propName={propName}
          label={label}
          defaultChecked={value || false}
          onChange={onChange}
        />
        <div className={`field-content ${!className ? 'grid grid--large' : ''}`}>
          <ButtonTag
            value={I18n.t('channelsConfigurations_schedule')}
            onClick={toggleModalSchedule}
            size={'large'}
          />
          {modalSchedule && <div className='modal-background'>
            <ScheduleModal
              scheduleMode={'nauta'}
              closeModal={toggleModalSchedule}
              saveSchedules={saveSchedule}
              schedules={scheduleNauta && Object.keys(scheduleNauta).length ? [scheduleNauta] : _clonedeep(schedule)} />
          </div>}
          {description && <p className='description'>{I18n.t(description)}</p>}
        </div>
      </div>
    </>
  )
}

export default IsActiveNauta
